import { OptionProps, components } from 'react-select';
import React from 'react';
import { enumValue } from '~/util';
import { GapOptionType } from '~/services';

export const gapTypeNames = {
    [enumValue(['gap', 'type', 'Risk Gap']) as number]: 'Attestation',
    [enumValue(['gap', 'type', 'FOC Gap']) as number]: 'AW',
    [enumValue(['gap', 'type', 'Quality Gap']) as number]: 'Quality',
};

export function GapOption(props: OptionProps<GapOptionType, true>) {
    return (
        <components.Option {...props}>
            <div className="name">{props.data.name}</div>
            <div className="description">
                {gapTypeNames[props.data.type]}
                {gapTypeNames[props.data.type] === 'Attestation'
                    ? ` - ${props.data.description}`
                    : ''}
            </div>
        </components.Option>
    );
}
